export default __webpack_public_path__ + "media/images/icons/icon-add-19bc60221e100db161fb8486ce2066ac.svg";